var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrowRightPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90339 7.82905C8.5296 8.28405 8.5296 9.01905 8.90339 9.47405L12.6221 14.0007L8.90339 18.5274C8.5296 18.9824 8.5296 19.7174 8.90339 20.1724C9.27717 20.6274 9.88098 20.6274 10.2548 20.1724L14.6539 14.8174C15.0277 14.3624 15.0277 13.6274 14.6539 13.1724L10.2548 7.81738C9.89056 7.37405 9.27717 7.37405 8.90339 7.82905Z",
    fill: "#6B2C90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0635 7.82905C14.6898 8.28405 14.6898 9.01905 15.0635 9.47405L18.7822 14.0007L15.0635 18.5274C14.6898 18.9824 14.6898 19.7174 15.0635 20.1724C15.4373 20.6274 16.0411 20.6274 16.4149 20.1724L20.8141 14.8174C21.1879 14.3624 21.1879 13.6274 20.8141 13.1724L16.4149 7.81738C16.0507 7.37405 15.4373 7.37405 15.0635 7.82905Z",
    fill: "#6B2C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRightPurple);
export default __webpack_public_path__ + "static/media/DoubleArrowRightPurple.386fcefbfe1880dc63b502d14e57733f.svg";
export { ForwardRef as ReactComponent };